import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesSecurityLevelDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-security-level-delete',
	path: '/secure/admin/DeleteIssueSecurityLevel!default.jspa',
};
